import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadPlan () {
    const api = getApiClient(this.$store)
    const planId = this.$route.params.id

    api.get(`plans/${planId}`)
      .then(result => {
        this.plan = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.plan.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'plans'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.plan['@id']
    }

    api[method](endpoint, this.plan, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Pacote salvo com sucesso')
        this.$router.push({
          name: 'Plans',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar pacote')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
